import React from 'react';
import { makeClassName } from '@siteless/util';

const BellStrikeThroughIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    className={makeClassName('BellStrikeThroughIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    {...rest}
  >
    <path d="M13.73 21a2 2 0 0 1-3.46 0" fill="none" />
    <path d="M18.63 13A17.89 17.89 0 0 1 18 8" fill="none" />
    <path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14" fill="none" />
    <path d="M18 8a6 6 0 0 0-9.33-5" fill="none" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

export default BellStrikeThroughIcon;
